<template>
  <div class="overseasGrid">
    <div class="searchTop">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="colItem1">
          <van-field
            readonly
            :value="areaName"
            :placeholder="$t.meta.select"
            @click-input="pickerShow('showAreaPicker')"
            class="custom-field"
            v-if="searchType == 1"
          >
            <template #button>
              <van-button size="small" type="info" @click="onSearch">{{
                $t.meta.search
              }}</van-button>
            </template>
          </van-field>
          <van-field
            readonly
            :value="countryName"
            :placeholder="$t.meta.select"
            @click-input="pickerShow('showCountryPicker')"
            class="custom-field"
            v-if="searchType == 2"
          >
            <template #button>
              <van-button size="small" type="info" @click="onSearch">{{
                $t.meta.search
              }}</van-button>
            </template>
          </van-field>
          <van-field
            readonly
            :value="cityName"
            :placeholder="$t.meta.select"
            @click-input="pickerShow('showCityPicker')"
            class="custom-field"
            v-if="searchType == 3"
          >
            <template #button>
              <van-button size="small" type="info" @click="onSearch">{{
                $t.meta.search
              }}</van-button>
            </template>
          </van-field>
          <van-field
            readonly
            :value="awName"
            :placeholder="$t.meta.select"
            @click-input="pickerShow('showAwPicker')"
            class="custom-field"
            v-if="searchType == 4"
          >
            <template #button>
              <van-button size="small" type="info" @click="onSearch">{{
                $t.meta.search
              }}</van-button>
            </template>
          </van-field>
        </van-col>
        <van-col class="colItem2">
          <div @click="handleSheetShow">
            <span>{{ searchTypeStr }}</span>
          </div>
        </van-col>
      </van-row>
    </div>

    <van-list
      class="list"
      v-model="loading"
      :finished="finished"
      :finished-text="$t.meta.noMore"
      :error.sync="error"
      :error-text="errorText"
      @load="getList(page + 1)"
    >
      <div
        class="list-container"
        v-for="(item, index) in tableData"
        :key="index"
        @click="gotoDetail(item.OASId)"
      >
        <div class="list-item">{{ $t.supplier.area }}：{{ item.RegionName }}</div>
        <div class="list-item">{{ $t.supplier.country }}：{{ item.CountryName }}</div>
        <div class="list-item">{{ $t.supplier.city }}：{{ item.City_cn }}</div>
        <div class="list-item">{{ $t.supplier.bcType }}：{{ item.BCName }}</div>
        <div class="list-item">{{ $t.supplier.code }}：{{ item.Code }}</div>
        <div class="list-item">{{ $t.supplier.companySn }}：{{ item.CompanyNameSn }}</div>
        <div class="list-item">
          {{ $t.supplier.costRecord }}：{{ item.CostRecordNumber }}
        </div>
        <div class="list-item">
          {{ $t.supplier.dealCount }}：{{ item.ClinchDealCount }}
        </div>
        <div class="list-item">{{ $t.supplier.awWay }}：{{ item.AWName }}</div>
      </div>
    </van-list>

    <van-popup v-model="showAreaPicker" round position="bottom">
      <van-picker
        :title="$t.supplier.area"
        show-toolbar
        :columns="areaList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="areaConfirm"
        @cancel="showAreaPicker = false"
      />
    </van-popup>

    <van-popup v-model="showCountryPicker" round position="bottom">
      <van-picker
        :title="$t.supplier.country"
        show-toolbar
        :columns="countryList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="countryConfirm"
        @cancel="showCountryPicker = false"
      />
    </van-popup>

    <van-popup v-model="showCityPicker" round position="bottom">
      <van-picker
        :title="$t.supplier.city"
        show-toolbar
        :columns="cityList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="cityConfirm"
        @cancel="showCityPicker = false"
      />
    </van-popup>

    <van-popup v-model="showAwPicker" round position="bottom">
      <van-picker
        :title="$t.supplier.awWay"
        show-toolbar
        :columns="awList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="awConfirm"
        @cancel="showAwPicker = false"
      />
    </van-popup>

    <van-action-sheet
      :title="$t.meta.searchType"
      :closeable="false"
      v-model="sheetShow"
      :actions="sheetActions"
      @select="sheetSelect"
    />

    <div class="tool-bar">
      <van-button type="info" block @click="gotoDetail(null)">{{
        $t.supplier.createQuote
      }}</van-button>
    </div>
  </div>
</template>

<script>
import {
  List,
  Row,
  Col,
  Search,
  Button,
  Form,
  Field,
  ActionSheet,
  Popup,
  Picker,
  DatetimePicker,
  Radio,
  RadioGroup,
} from "vant";

import Vue from "vue";
Vue.use(List)
  .use(Row)
  .use(Col)
  .use(Search)
  .use(Button)
  .use(Form)
  .use(Field)
  .use(ActionSheet)
  .use(Popup)
  .use(Picker)
  .use(DatetimePicker)
  .use(Radio)
  .use(RadioGroup);

export default {
  name: "overseasGrid",
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      searchType: 1,
      searchTypeStr: this.$t.supplier.area,
      page: 0,
      pageSize: 10,
      tableData: [],
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      //options
      settings: [],
      areaList: [],
      countryList: [],
      cityList: [],
      awList: [],
      //filter
      areaName: "",
      areaValue: null,
      countryName: "",
      countryValue: null,
      cityName: "",
      cityValue: null,
      awName: "",
      awValue: null,
      showFilter: false,
      showAreaPicker: false,
      showCountryPicker: false,
      showCityPicker: false,
      showAwPicker: false,
      //操作菜单
      sheetShow: false,
      sheetActions: [],
    };
  },
  created() {
    this.getOptions();
  },
  methods: {
    areaConfirm(e) {
      this.areaName = e.text;
      this.areaValue = e.value;
      this.showAreaPicker = false;
    },
    countryConfirm(e) {
      this.countryName = e.text;
      this.countryValue = e.value;
      this.showCountryPicker = false;
    },
    cityConfirm(e) {
      this.cityName = e.text;
      this.cityValue = e.value;
      this.showCityPicker = false;
    },
    awConfirm(e) {
      this.awName = e.text;
      this.awValue = e.value;
      this.showAwPicker = false;
    },
    pickerShow(pickerName) {
      this[pickerName] = true;
    },
    sheetSelect(e) {
      this.searchTypeStr = e.name;
      this.searchType = e.className;
      this.sheetShow = false;
    },
    handleSheetShow() {
      var actions = [
        { name: this.$t.supplier.area, className: "1" },
        { name: this.$t.supplier.country, className: "2" },
        { name: this.$t.supplier.city, className: "3" },
        { name: this.$t.supplier.awWay, className: "4" },
      ];
      this.sheetActions = actions;
      this.sheetShow = true;
    },
    gotoDetail(id) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "overseasDetail",
        name: "overseasDetail",
        query: [
          {
            name: "OASId",
            value: id,
          },
        ],
      });
    },
    onSearch() {
      this.initList();
      this.getList(1);
    },
    initList() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.tableData = [];
    },
    filterReset() {
      this.beginTime = "";
      this.endTime = "";
      this.initList();
      this.getList(1);
    },
    filterSubmit() {
      this.initList();
      this.getList(1);
    },
    getList(page) {
      var param = {
        PageIndex: page,
        PageSize: this.pageSize,
        CompanyId: this.CompanyId,
        RegionId: this.searchType == 1 ? this.areaValue : null,
        CountryId: this.searchType == 2 ? this.countryValue : null,
        CityId: this.searchType == 3 ? this.cityValue : null,
        AWId: this.searchType == 4 ? this.awValue : null,
      };
      this.$api.supplier
        .getOverseasAgentServiceList(param)
        .then((res) => {
          this.tableData = this.tableData.concat(res.data.Data);
          this.loading = false;
          this.error = false;
          this.errorText = "";

          this.page = res.meta.page;
          this.finished = this.page >= res.meta.lastPage;
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
    getOptions() {
      return new Promise((resolve) => {
        Promise.all([
          this.getOverseasAgentServiceSetting(),
          this.getCountryList(),
          this.getCityList(),
        ]).then((success) => {
          if (success) resolve(true);
        });
      });
    },
    getOverseasAgentServiceSetting() {
      return new Promise((resolve) => {
        this.$api.supplier
          .getOverseasAgentServiceSetting()
          .then((res) => {
            this.settings = res.data;

            var awList = [];
            this.settings[0].forEach((item) => {
              let data = {
                text: item.AWName,
                value: item.AWId,
              };
              awList.push(data);
            });
            this.awList = this.$commonMethod.deepClone(awList);

            var areaList = [];
            this.settings[3].forEach((item) => {
              let data = {
                text: item.RegionName,
                value: item.RegionId,
              };
              areaList.push(data);
            });
            this.areaList = this.$commonMethod.deepClone(areaList);

            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getCountryList() {
      return new Promise((resolve) => {
        this.$api.customerManagement
          .getCountryList()
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.CountryName + "," + item.CountryName_en,
                value: item.CountryId,
              };
              result.push(data);
            });
            this.countryList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getCityList() {
      return new Promise((resolve) => {
        this.$api.logisticsManagement
          .getCountryList({
            type: 1,
          })
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.City_cn + "," + item.City_en,
                value: item.Id,
              };
              result.push(data);
            });
            this.cityList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.overseasGrid {
  .searchTop {
    width: 100%;
    background-color: #ffffff;
    border-bottom: 1px solid #ebedf0;
    .search-top-row {
      width: 100%;
      text-align: center;
      background-color: transparent;
      .colItem1 {
        width: 80%;
        text-align: center;
        font-size: 14px;
        .custom-field {
          padding: 10px 0px 10px 15px;
        }
      }
      .colItem2 {
        width: 20%;
        text-align: center;
        font-size: 14px;
      }
    }
  }
  .list {
    .list-container {
      font-size: 12px;
      color: #333;
      padding: 10px;
      margin-top: 10px;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
      .list-item {
        margin-bottom: 10px;
      }
      .list-item:last-child {
        margin-bottom: 0px;
      }
      .buttons {
        text-align: right;
        .primary-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-primary;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .default-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-light-gray;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .search-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-green;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .danger-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-red;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
      }
    }
  }
  .popup-header {
    margin-top: 20px;
    margin-bottom: 10px;
    padding-bottom: 10px;
    text-align: center;
    font-size: 16px;
  }
  .radio-label {
    color: #646566;
    margin-bottom: 10px;
    font-size: 14px;
  }
  .van-radio-group {
    margin-bottom: 20px;
  }
  .van-radio {
    margin-bottom: 10px;
    font-size: 14px;
    ::v-deep .van-radio__label {
      color: #646566;
    }
  }
  .van-form {
    width: 90%;
    margin: auto;
    padding-bottom: 20vw;
    .van-cell:after {
      border: none;
    }
    .van-cell {
      border-bottom: 1px solid #ebedf0;
    }
  }
  .popup-footer {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 100;
    background-color: white;
    padding-bottom: env(safe-area-inset-bottom);
    width: 100%;
    .reset {
      width: 50%;
      display: inline-block;
      color: $-color-primary;
      background: #ffffff;
      border: none;
    }
    .confirm {
      width: 50%;
      display: inline-block;
      color: #ffffff;
      background: $-color-primary;
      border: none;
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
